import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
import './magacin.css';
// import Serviced_vehicles from './Components/serviced_vehicles.js';
import { Toast } from 'primereact/toast';
import { TabMenu } from 'primereact/tabmenu';
import Unos_artikla from './Tab_components/Artical/Unos_artikla'; //STARI SISTEM UNOSA ARTIKLA, KOMPLIKOVANIJI
import UnosArtiklaKonfig from './Tab_components/Artical/Unos_artikla_konfig';
import PregledZaliha from './Tab_components/Pregled_zaliha/Pregled_zaliha';
import PregledGuma from './Tab_components/Pregled_guma/Pregled_guma';
import NovaPrijemnica from './Tab_components/Nova_prijemnica/Nova_prijemnica';
import PregledPrijemnice from './Tab_components/Pregled_prijemnice/Pregled_prijemnice';
import NovaOtpremnica from './Tab_components/Nova_otpremnica/Nova_otpremnica';
import PregledOtpremnice from './Tab_components/Pregled otpremnice/Pregled_otpremnice';
import Magacin from './Tab_components/Magacin/Magacin';
import PumpeHome from './Tab_components/Pumpa/Pumpe_home';
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AuthContext } from "../../Header/auth - context";
// import { useSelector } from 'react-redux';

const Magacin_home = () => {
  const { t } = useTranslation();

    const toast = useRef(null);
    const auth = useContext(AuthContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const [changeArtical, setChangeArtical] = useState(false);
    const [idReceiverDispacher, setIdReceiverDispacher] = useState(null);
    const company = useSelector((state) => state.company);
    const user = useSelector((state) => state.user);
    const location = useLocation();              
    const [klijentiOptions, setKlijentiOptions] = useState([]);
    const [magacinOptions, setMagacinOptions] = useState([]);
    const [nazivArtiklaOptions, setNazivArtiklaOptions] = useState([]);
    const [jedinicaMereOptions, setJedinicaMereOptions] = useState([]);
    /* Valute za cene artikala — sifarnik i podrazumevana valuta firme. */
    const [valutaOptions, setValutaOptions] = useState([]);
    const [statusiOptions, setStatisiOptions] = useState([]);
    const [tipoviOptions, setTipoviOptions] = useState([]);
    const [vozilaOptions, setVozilaOptions] = useState([]);
    /* Interni vozaci — za otpremnicu tipa INTERNO. */
    const [vozaciOptions, setVozaciOptions] = useState([]);
    const [zalihaOptions, setZalihaOptions] = useState([]);
    const [gumaZalihaOptions, setGumaZalihaOptions] = useState([]);

      const handleErrors = (response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw response;
        }
      };
    
      useEffect( () => {

        if(!changeArtical) {
              let requestOptions = {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: "Bearer " + auth.token,
                        }
                      };
                  
                      fetch(
                        process.env.REACT_APP_BACKEND_URL + "/warehouse/GetWarehouseAndTypes",
                        requestOptions
                      )
                        .then(handleErrors)
                        .then((data) => {
                              const stringifiedJson = data[0][""];
                              const parsedData = JSON.parse(stringifiedJson);

                          setKlijentiOptions(parsedData?.ClientsDB);
                          setMagacinOptions(parsedData?.MagacinDB);
                          setNazivArtiklaOptions(parsedData?.NazivArtiklaDB);
                          setJedinicaMereOptions(parsedData?.JediniceMereDB);
                          setValutaOptions(parsedData?.ValuteDB || []);
                          setStatisiOptions(parsedData?.StatusiOtpremeDB);
                          setTipoviOptions(parsedData?.TipoviOtpremeDB);
                          setVozilaOptions(parsedData?.VozilaDB);
                          setVozaciOptions(parsedData?.VozaciDB || []);
                          setZalihaOptions(parsedData?.ZalihaDB || []);
                          setGumaZalihaOptions(parsedData?.GumaZalihaDB || []);
                  
                        })
                        .catch((error) => {
                          error.json().then((errorMessage) => {
                            toast.current.show({
                              severity: "error",
                              summary: "Error",
                              detail: errorMessage.message,
                              life: 3000,
                            });
                            console.log(errorMessage);
                          });
                        });
        }
        
      }, [activeIndex,changeArtical]);    

    /* Sigurnosna kocnica za zastavicu sifarnika: promena taba je spusta.
       Dok je dignuta, spiskovi se ne ucitavaju — a ostati zaglavljen u tom
       stanju znaci prazne padajuce spiskove na celom modulu. */
    useEffect(() => {
      if (changeArtical) setChangeArtical(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex]);

    useEffect(() => {
      return () => {
        setIdReceiverDispacher(null);
      };
    }, [location.key]);

    const items = [
        { label: 'PREGLED ZALIHA'},
        { label: 'PREGLED GUMA'},
        { label: 'NOVA PRIJEMNICA'},
        { label: 'PREGLED PRIJEMNICE'},
        { label: 'NOVA OTPREMNICA'},
        { label: 'PREGLED OTPREMNICE'},
        { label: 'MAGACIN'},
        { label: 'PUMPA'},
        /* Jedini prevedeni naziv u listi — ostali su zatečeni hardkodovani i
           ne diraju se usput; novi string mora kroz i18n (vidi CLAUDE.md). */
        { label: t('magacin.tabArtikal')}
    ];
    return(
        <div className="Magacin_home">
        <Toast ref={toast} />
            <div id='Magacin_tabs'>
                <TabMenu id='modelTabMagacin' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ marginBottom: '0' }} model={items} />

                {activeIndex === 0 && <PregledZaliha/>}
                {activeIndex === 1 && <PregledGuma/>}
                {activeIndex === 2 && <NovaPrijemnica idReceiver={idReceiverDispacher?.source === 'prijemnica' ? idReceiverDispacher.id : null} klijentiOptions={klijentiOptions}
                                      magacinOptions={magacinOptions}   nazivArtiklaOptions={nazivArtiklaOptions} setIdReceiverDispacher={setIdReceiverDispacher}
                                      jedinicaMereOptions={jedinicaMereOptions} setChangeArtical={setChangeArtical} changeArtical={changeArtical}/>}
                {activeIndex === 3 && <PregledPrijemnice setIdReceiverDispacher={setIdReceiverDispacher} setActiveIndex={setActiveIndex}/>}
                {activeIndex === 4 && <NovaOtpremnica idDispacher={idReceiverDispacher?.source === 'otpremnica' ? idReceiverDispacher.id : null} klijentiOptions={klijentiOptions}
                                      magacinOptions={magacinOptions} statusiOptions={statusiOptions} tipoviOptions={tipoviOptions}
                                      vozilaOptions={vozilaOptions} vozaciOptions={vozaciOptions} nazivArtiklaOptions={nazivArtiklaOptions} setIdReceiverDispacher={setIdReceiverDispacher}
                                      jedinicaMereOptions={jedinicaMereOptions} setChangeArtical={setChangeArtical} changeArtical={changeArtical}
                                      zalihaOptions={zalihaOptions} gumaZalihaOptions={gumaZalihaOptions} valutaOptions={valutaOptions}/>}
                {activeIndex === 5 && <PregledOtpremnice setIdReceiverDispacher={setIdReceiverDispacher} setActiveIndex={setActiveIndex}/>}
                {activeIndex === 6 && <Magacin/>}
                {activeIndex === 7 && <PumpeHome/>}
                {/* Isti ekran koji se otvara na „+" pored Naziva artikla u Novoj
                    prijemnici — komponenta se DELI, ne kopira, da podešavanje
                    artikla ne postoji na dva mesta u dve verzije. */}
                {activeIndex === 8 && <UnosArtiklaKonfig setChangeArtical={setChangeArtical}/>}
            </div>

        </div>

    )
}
export default Magacin_home;